import { render } from "./InviteFriends.vue?vue&type=template&id=429e6c9a"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__